import { TradingShell } from '@/components/trading/TradingShell';

/**
 * Live Trading — real-money trading on funded broker accounts. Now uses the same
 * shared {@link TradingShell} as Paper Trading: asset tabs (Equity | Forex) ×
 * view tabs (Manual | Automated), with the real-money confirm + red banners.
 *
 * - Equity → Manual: live Alpaca order ticket (real money).
 * - Forex  → Manual: live FXCM panel (real money).
 * - Automated cells: surfaced as their backend wiring lands (see TradingShell).
 */
export function LiveTradingPage() {
  return <TradingShell environment="live" />;
}

export default LiveTradingPage;
